import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import returnsReportService from "services/returnsReportService";

const initialState = {
  loading: false,
  detailLoading: false,
  reportData: null,
  detailData: null,
  message: "",
  showMessage: false,
};

export const getReturnsReport = createAsyncThunk(
  "returnsReport/getReturnsReport",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await returnsReportService.getReturnsReport(params);
      return response;
    } catch (err) {
      return rejectWithValue(err.message || "Error fetching returns report");
    }
  }
);

export const getReturnsReportDetail = createAsyncThunk(
  "returnsReport/getReturnsReportDetail",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await returnsReportService.getReturnsReportDetail(params);
      return response;
    } catch (err) {
      return rejectWithValue(
        err.message || "Error fetching returns report detail"
      );
    }
  }
);

const returnsReportSlice = createSlice({
  name: "returnsReport",
  initialState,
  reducers: {
    clearReturnsMessage: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    clearDetailData: (state) => {
      state.detailData = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getReturnsReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(getReturnsReport.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.reportData = payload;
      })
      .addCase(getReturnsReport.rejected, (state, { payload }) => {
        state.loading = false;
        state.message = payload;
        state.showMessage = true;
      })
      .addCase(getReturnsReportDetail.pending, (state) => {
        state.detailLoading = true;
      })
      .addCase(getReturnsReportDetail.fulfilled, (state, { payload }) => {
        state.detailLoading = false;
        state.detailData = payload;
      })
      .addCase(getReturnsReportDetail.rejected, (state, { payload }) => {
        state.detailLoading = false;
        state.message = payload;
        state.showMessage = true;
      });
  },
});

export const { clearReturnsMessage, clearDetailData } =
  returnsReportSlice.actions;
export default returnsReportSlice.reducer;
